import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c(VTabs,{attrs:{"vertical":""}},[_vm._l((_vm.tipos),function(tipo){return _c(VTab,{key:tipo.idArticuloTipo,domProps:{"innerHTML":_vm._s(tipo.nombre.replace(' ','<br>'))}})}),_vm._l((_vm.tipos),function(tipo){return _c(VTabItem,{key:'a'+tipo.idArticuloTipo},[_c('reglaArticulo',{attrs:{"idArticuloTipo":tipo.idArticuloTipo}})],1)})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }